<mat-form-field appearance="outline" class="field-control w-100">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [value]="value || ''"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keyup)="onChange($event)"
    [placeholder]="placeholder || ''"

    type="phone"
  />
</mat-form-field>
